<template>
  <div>
    <div
      v-show="mostrarSelectores"
      class="buscador row col-12 mx-auto my-4 px-0"
    >
      <SelectorCarrera
        labelSelector="Selección 1:"
        classSelector="sel1"
        @seleccionarCarrera="seleccion1"
        @reiniciarSeleccion="carreraSeleccionada1 = ''"
      />
      <SelectorCarrera
        labelSelector="Selección 2:"
        classSelector="sel2"
        @seleccionarCarrera="seleccion2"
        @reiniciarSeleccion="carreraSeleccionada2 = ''"
      />

      <div class="row w-100 px-0 mt-3 ml-0 mx-md-auto">
        <!-- botón Comparar para desktop -->
        <div
          class="col-7 mx-auto px-0 input-lg align-self-center d-none d-lg-block"
        >
          <button
            @click="comparar"
            :disabled="habilitarBotonComparar"
            class="btn btn-blue rounded-0 w-100 px-3 collapsed"
            style="height: 2.625rem"
          >
            COMPARAR
          </button>
        </div>
        <!-- botón Comparar para móviles -->
        <div
          class="col-12 mx-auto input-lg align-self-center d-block d-lg-none"
        >
          <button
            @click="comparar"
            :disabled="habilitarBotonComparar"
            class="btn btn-blue w-100 rounded-0 collapsed"
          >
            COMPARAR
          </button>
        </div>
      </div>
    </div>
    <!--TEXTO LUEGO DE SELECCION -->
    <div class="buscador row col-12 mx-auto my-4 px-0">
      <div v-if="mostrarSeleccion" class="row w-100 px-0 mt-3 ml-0 mx-md-auto">
        <!-- versión desktop -->
        <div class="col-12 col-md-10 mx-auto d-none d-md-flex mb-4">
          <div class="col-12 col-md-6 sel1 d-flex">
            <div class="col-4"><h4>Carrera&nbsp;1:</h4></div>
            <div class="tit-carrera col pl-2">
              {{ carreraSeleccionada1.toUpperCase() }}
            </div>
          </div>

          <div class="col-12 col-md-6 sel2 d-flex">
            <div class="col-4"><h4>Carrera&nbsp;2:</h4></div>
            <div class="tit-carrera">
              {{ carreraSeleccionada2.toUpperCase() }}
            </div>
          </div>
        </div>
        <div
          class="col-7 mx-auto px-0 input-lg align-self-center d-none d-lg-block"
        >
          <button
            @click="editar"
            class="btn btn-blue rounded-0 w-100 px-3 collapsed"
            style="height: 2.625rem"
          >
            EDITAR
          </button>
        </div>

        <!-- versión móviles -->
        <div class="col-12 mx-auto d-block d-md-none px-0">
          <div class="col-12 sel1">
            <div class="d-flex">
              <h4 class="col-7 ml-2">Seleccionadas:</h4>
              <div class="col-4 ml-auto input-lg px-0"></div>
            </div>
            <ol class="pl-3 mb-0">
              <li class="tit-carrera pt-2">
                {{ carreraSeleccionada1.toUpperCase() }}
              </li>
              <li class="tit-carrera">
                {{ carreraSeleccionada2.toUpperCase() }}
              </li>
            </ol>
          </div>

          <div class="row w-100 px-0 mt-3 ml-0 mx-md-auto">
            <!-- botón Editar para móviles -->
            <div
              class="col-12 mx-auto input-lg align-self-center d-block d-lg-none"
            >
              <button
                @click="editar"
                class="btn btn-blue w-100 rounded-0"
                id="inputGroupFileAddon"
              >
                EDITAR
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiComparadorTP from "@/services/ApiComparadorTP";
import SelectorCarrera from "@/components/comparadorITP/SelectorCarrera";
export default {
  name: "FormComparador",
  components: {
    SelectorCarrera
  },
  data() {
    return {
      carreraSeleccionada1: "",
      carreraSeleccionada2: "",
      mostrarSeleccion: false,
      mostrarSelectores: true
    };
  },
  computed: {
    habilitarBotonComparar() {
      return (
        this.carreraSeleccionada1 === "" ||
        this.carreraSeleccionada2 === "" ||
        this.carreraSeleccionada1 === this.carreraSeleccionada2
      );
    }
  },
  methods: {
    seleccion1(val) {
      this.carreraSeleccionada1 = val;
    },
    seleccion2(val) {
      this.carreraSeleccionada2 = val;
    },
    comparar() {
      if (this.validarComparacion()) {
        let selecciones = [
          this.carreraSeleccionada1,
          this.carreraSeleccionada2
        ];
        this.$emit("comparar", selecciones);
        this.mostrarSeleccion = !this.mostrarSeleccion;
        this.mostrarSelectores = !this.mostrarSelectores;
      }
    },
    editar() {
      this.$emit("limpiarComparacion");
      this.mostrarSeleccion = !this.mostrarSeleccion;
      this.mostrarSelectores = !this.mostrarSelectores;
    },
    validarComparacion() {
      if (
        this.carreraSeleccionada1 === "" ||
        this.carreraSeleccionada2 === ""
      ) {
        return false;
      } else if (this.carreraSeleccionada1 === this.carreraSeleccionada2) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/comparadorITP/FormComparador.vue